<ng-container *ngIf="hasData; else emptySeries">
  <!-- A ressalva das semanas parciais vive DENTRO deste aviso, e não num po-info
       próprio nem no rótulo do eixo: ela é sobre o mesmo agrupamento que este aviso
       anuncia, e marcar "(parcial)" no eixo pagaria o custo em todos os rótulos para
       explicar no máximo dois baldes. Ver `groupingNote` no componente. -->
  <po-info
    *ngIf="weekly"
    p-label="Agrupado"
    [p-value]="groupingNote"
    p-orientation="horizontal">
  </po-info>

  <po-info
    *ngIf="peakLabel"
    p-label="Pico do período"
    [p-value]="peakLabel"
    p-orientation="horizontal">
  </po-info>

  <po-chart
    [p-type]="columnType"
    [p-categories]="categories"
    [p-series]="series"
    [p-height]="300">
  </po-chart>
</ng-container>

<ng-template #emptySeries>
  <p class="po-font-text-small">Nenhuma execução neste período.</p>
</ng-template>
